module.exports = __webpack_public_path__ + "img/hedgehog-7922370_1280_thumb.524c896d.jpg";